/* eslint-disable */
export default class ManageDealUpdateNewPayload {
  constructor(data = {}) {

    
    this.id = data.id;
    this.status = data.status;
    this.statusText = data.statusText;
    //Configuration
    this.ambCustomerBarcodeImg = data.configuration.ambCustomerBarcodeImg;
    this.ambEnableDealToCustomer = data.configuration.ambEnableDealToCustomer;
    this.setName = data.configuration.setName;
    this.ambEmailReminder = data.configuration.ambEmailReminder;
    this.ambEnableAmbassadorMails = data.configuration.ambEnableAmbassadorMails;
    this.setAnimateDealSetting = data.configuration.setAnimateDealSetting;
    this.setLanguage = data.configuration.setLanguage;
    this.setSiteId = data.configuration.setSiteId;
    this.setTagName = data.configuration.setTagName;
    this.setTargetCampaignURL = data.configuration.setTargetCampaignURL;
    this.setGeneratedShortenURL = data.configuration.setGeneratedShortenURL;
    this.ambConversionDays = data.configuration.ambConversionDays;
    this.ambReferralSessionBlockTime =
      data.configuration.ambreferralSessionBlockTime;
    this.setloadingPreset = data.configuration.setloadingPreset;
    this.ambNeverDisplay = data.configuration.ambNeverDisplay;
    this.ambAllowexistingmember = data.configuration.ambAllowexistingmember;
    this.setIsCollectCPOEmailPhone =
      data.configuration.setisCollectCPOEmailPhone;
    this.ambShowinfomis = data.configuration.ambShowinfomis;
    this.ambOpenAsMinimized = data.configuration.ambOpenAsMinimized;
    this.ambndmw = data.configuration.ambndmw;
    this.ambHintButMaskCode = data.configuration.ambHintButMaskCode;
    this.ambAllowMinimizeOnLastStep =
      data.configuration.amballowMinimizeOnLastStep;
    this.ambYourCodeWillShowHereText =
      data.configuration.ambYourCodeWillShowHereText;
    this.ambReqEmailVer = data.configuration.ambReqEmailVer;
    this.setIsSendReminderAlways = data.configuration.setIsSendReminderAlways;
    this.setEnableUTMTags = data.configuration.setEnableUTMTags;
    this.ambDisFriendFlow = data.configuration.ambDisFriendFlow;

    this.setRedirecttxt = data.configuration.setRedirecttxt;
    this.ambPriority = data.configuration.ambPriority;
    this.ambAmbassadorDealTagAfterCompletion =
      data.configuration.ambassadorDealTagAfterCompletion;
    this.ambOpenDealbytagFornewmember =
      data.configuration.ambOpenDealbytagFornewmember;
    this.ambRUAR = data.configuration.ambRUAR;
    this.ambOpenDealTagForExistingMember =
      data.configuration.ambopenDealTagForExistingMember;
    this.setRedirectbtntxt = data.configuration.setRedirectbtntxt;
    this.ambNPSType = data.configuration.ambNPSType;
    this.ambNPSTitle = data.configuration.ambNPSTitle;
    this.ambNPSMessage = data.configuration.ambNPSMessage;

    //target
    this.triggerDropdown = data.target.triggerDropdown;

    //rewards
    this.ambVoyadoReward = data.rewards.ambvoyadoReward;
    this.ambCustomerDynamicCodesActualFilename =
      data.rewards.ambCustomerDynamicCodesActualFilename;
    this.ambVoyadoPromoId = data.rewards.ambVoyadoPromoId;
    this.ambVoyadobonuspoint = data.rewards.ambvoyadobonuspoint;
    this.ambdynamicCodesFileListItems =
      data.rewards.ambdynamicCodesFileListItems;
    this.ambreplacefiles = data.rewards.ambreplacefiles;
    this.ambCustomerLowCodeLimit = data.rewards.ambCustomerLowCodeLimit;
    this.ambCustomerLowCodeAlertLimit =
      data.rewards.ambCustomerLowCodeAlertLimit;
    this.ambshowdeniedoutofcodemsg = data.rewards.ambshowdeniedoutofcodemsg;
    this.amboutofcodemsgtitle = data.rewards.amboutofcodemsgtitle;
    this.amboutofcodemsgbody = data.rewards.amboutofcodemsgbody;
    this.ambCustomerStaticCode = data.rewards.ambCustomerStaticCode;
    this.ambMobileSwipe = data.rewards.ambMobileSwipe;
    this.ambswipemodalheader = data.rewards.ambswipemodalheader;
    this.ambswipemodaltext = data.rewards.ambswipemodaltext;
    this.ambswipemodalccode = data.rewards.ambswipemodalccode;
    this.ambswipebtnexpand = data.rewards.ambswipebtnexpand;
    this.ambAmbassadorRewardTime = data.rewards.ambAmbassadorRewardTime;
    this.ambSwipebtncancel = data.rewards.ambSwipebtncancel;
    this.ambCustomerIsTimeSpanCoupon = data.rewards.ambCustomerIsTimeSpanCoupon;
    this.ambCustomerTimeSpanDaysAmount =
      data.rewards.ambCustomerTimeSpanDaysAmount;
    this.ambcustomerCodeExpirationDate =
      data.rewards.ambcustomerCodeExpirationDate;
    this.ambCustomerCampaignDealyDays =
      data.rewards.ambCustomerCampaignDealyDays;
    this.ambshowVoyadoPromo = data.rewards.ambshowVoyadoPromo;
    this.ambisVoyadoPromo = data.rewards.ambisVoyadoPromo;
    this.ambCustomerLowCodeAlertLimitDefault =
      data.rewards.ambCustomerLowCodeAlertLimitDefault;
    this.ambCustomerDynamicCodesFilename =
      data.rewards.ambCustomerDynamicCodesFilename;
    this.ambCustomerDynamicCodesFullPath =
      data.rewards.ambCustomerDynamicCodesFullPath;
    this.ambCustomerDynamicCodesStream =
      data.rewards.ambCustomerDynamicCodesStream;
    this.ambCustomerUseDynamicCodes = data.rewards.ambCustomerUseDynamicCodes;
    this.ambRewardtype = data.rewards.ambRewardtype;
    this.ambCustomerTotalCodesUpdate = data.rewards.ambCustomerTotalCodesUpdate;
    this.ambCustomerLowCodeLimitDefault =
      data.rewards.ambCustomerLowCodeLimitDefault || 150;

    //Refferal Settings
    this.ambDisablereferrals = data.referrals.ambDisablereferrals;
    this.setAmbassadorInfoInFriendLink =
      data.referrals.setAmbassadorInfoInFriendLink;
    this.ambfrndlnkexp = data.referrals.ambfrndlnkexp;
    //grecy
    // this.setAnimateDealSetting = data.referrals.setAnimateDealSetting;
    // this.setEnableUTMTags = data.referrals.setEnableUTMTags;
    // this.ambDisFriendFlow = data.referrals.ambDisFriendFlow;
    //end
    this.ambFlowType = data.referrals.ambFlowType;
    this.ambContactInfoAsUrlParam = data.referrals.ambContactInfoAsUrlParam;
    this.setHasFacebookChannel = data.referrals.setHasFacebookChannel;
    this.setHasNativeMailChannel = data.referrals.setHasNativeMailChannel;
    this.setHasNativeSmsChannel = data.referrals.setHasNativeSmsChannel;
    this.setHasTrueCallerChannel = data.referrals.setHasTrueCallerChannel;
    this.setHasWhatsappChannel = data.referrals.setHasWhatsappChannel;
    this.setHasSharebleLinkChannel = data.referrals.setHasSharebleLinkChannel;
    this.setHasTwitterChannel = data.referrals.setHasTwitterChannel;
    this.setHasTelegramChannel = data.referrals.setHasTelegramChannel;
    this.setHasLineChannel = data.referrals.setHasLineChannel;
    this.setHasKakaotalkChannel = data.referrals.setHasKakaotalkChannel;
    this.setHasWebShareChannel = data.referrals.setHasWebShareChannel;
    this.setHasQRChannel = data.referrals.setHasQRChannel;
    this.setHasPageShareChannel = data.referrals.setHasPageShareChannel;
    this.setHasSkypeChannel = data.referrals.setHasSkypeChannel;
    this.setHasWeChatChannel = data.referrals.setHasWeChatChannel;
    this.setHasInstagramChannel = data.referrals.setHasInstagramChannel;
    this.setHasDiscordChannel = data.referrals.setHasDiscordChannel;
    this.setHasSignalChannel = data.referrals.setHasSignalChannel;
    this.ambDisplayCTAbuttons = data.referrals.ambDisplayCTAbuttons;
    this.ambEnableChannelButtonAnimation =
      data.referrals.ambEnableChannelButtonAnimation;
    this.messengerTitle = data.referrals.messengerTitle;
    this.messengerText = data.referrals.messengerText;
    this.emailChannelSubject = data.referrals.emailChannelSubject;
    this.emailChannelBody = data.referrals.emailChannelBody;
    this.smsChannelBody = data.referrals.smsChannelBody;
    this.trueCallerDescription = data.referrals.trueCallerDescription;
    this.trueCallerDescriptionPointer =
      data.referrals.trueCallerDescriptionPointer;
    this.whatsappChannelBody = data.referrals.whatsappChannelBody;
    this.shareableLinkTitle = data.referrals.shareableLinkTitle;
    this.shareableLinkDesc = data.referrals.shareableLinkDesc;
    this.shareableLinkMessageToFriends =
      data.referrals.shareableLinkMessageToFriends;
    this.twitterChannelTitle = data.referrals.twitterChannelTitle;
    this.twitterChannelDesc = data.referrals.twitterChannelDesc;
    this.twitterChannelBody = data.referrals.twitterChannelBody;
    this.telegramChannelBody = data.referrals.telegramChannelBody;
    this.lineChannelTitle = data.referrals.lineChannelTitle;
    this.lineChannelDesc = data.referrals.lineChannelDesc;
    this.lineChannelBody = data.referrals.lineChannelBody;
    this.kakaotalkChannelWidgetTitle =
      data.referrals.kakaotalkChannelWidgetTitle;
    this.kakaotalkChannelWidgetDesc = data.referrals.kakaotalkChannelWidgetDesc;
    this.kakaotalkChannelTitle = data.referrals.kakaotalkChannelTitle;
    this.kakaotalkChannelBody = data.referrals.kakaotalkChannelBody;
    this.kakaotalkChannelButtonText = data.referrals.kakaotalkChannelButtonText;
    this.webShareTitle = data.referrals.webShareTitle;
    this.webShareBody = data.referrals.webShareBody;
    this.qRbody = data.referrals.qRbody;
    this.qRheader = data.referrals.qRheader;
    this.pageShareDescription = data.referrals.pageShareDescription;
    this.pageShareDescriptionPointer =
      data.referrals.pageShareDescriptionPointer;
    this.skypeTitle = data.referrals.skypeTitle;
    this.skypeText = data.referrals.skypeText;
    this.wechatdescription = data.referrals.wechatdescription;
    this.wechatdescriptionpointer = data.referrals.wechatdescriptionpointer;
    this.instagramdescription = data.referrals.instagramdescription;
    this.instagramdescriptionpointer =
      data.referrals.instagramdescriptionpointer;
    this.discorddescription = data.referrals.discorddescription;
    this.discorddescriptionpointer = data.referrals.discorddescriptionpointer;
    this.signaldescription = data.referrals.signaldescription;
    this.signaldescriptionpointer = data.referrals.signaldescriptionpointer;

    this.setShowFacebookChannelOption =
      data.referrals.setShowFacebookChannelOption;
    this.setShowMailChannelOption = data.referrals.setShowMailChannelOption;
    this.showSMSChannelOption = data.referrals.setShowSMSChannelOption;
    this.setShowTrueCallerChannelOption =
      data.referrals.setShowTrueCallerChannelOption;
    this.setShowWhatsappChannelOption =
      data.referrals.setShowWhatsappChannelOption;
    this.setShowSharebleLinkChannelOption =
      data.referrals.setShowSharebleLinkChannelOption;
    this.setShowTwitterChannelOption =
      data.referrals.setShowTwitterChannelOption;
    this.setShowTelegramChannelOption =
      data.referrals.setShowTelegramChannelOption;
    this.setShowQRLinkChannelOption = data.referrals.setShowQRLinkChannelOption;
    this.showWeChatChannelOption = data.referrals.showWeChatChannelOption;
    this.setShowWebShareChannelOption =
      data.referrals.setShowWebShareChannelOption;
    this.setShowLineChannelOption = data.referrals.setShowLineChannelOption;
    this.setShowKakaotalkChannelOption =
      data.referrals.setShowKakaotalkChannelOption;
    this.setShowSkypeChannelOption = data.referrals.setShowSkypeChannelOption;
    this.setShowDiscordChannelOption =
      data.referrals.setShowDiscordChannelOption;
    this.setShowSignalChannelOption = data.referrals.setShowSignalChannelOption;
    this.setShowInstagramChannelOption =
      data.referrals.setShowInstagramChannelOption;
    this.showPageShareChannelOption = data.referrals.showPageShareChannelOption;

    //Scheduling
    this.pubStartDate = data.scheduling.pubStartDate;
    this.pubEndDate = data.scheduling.pubEndDate;
    this.pubPauseDate = data.scheduling.pubPauseDate;
    this.pubRePublishDate = data.scheduling.pubRePublishDate;
    this.pubIsEndDateEnable = data.scheduling.pubIsEndDateEnable;
    this.pubOldEndDate = data.scheduling.pubOldEndDate;

    //Friend configuration
    this.setDealLandingPage = data.friendconfig.setDealLandingPage;
    this.setLandingPageUrl = data.friendconfig.setLandingPageUrl;
    this.friConversionDays = data.friendconfig.friConversionDays;
    this.friReferralSessionBlockTime =
      data.friendconfig.friReferralSessionBlockTime;
    this.friendIsEnableRewardCode = data.friendconfig.friendIsEnableRewardCode;
    this.friendIsShowFriendCode = data.friendconfig.friendIsShowFriendCode;
    this.friendRewardTime = data.friendconfig.friendRewardTime;
    this.friAllowFriendExistingMember =
      data.friendconfig.friAllowFriendExistingMember;
    this.friCombinecodeinfo = data.friendconfig.friCombinecodeinfo;
    this.friendHideOptinFriend = data.friendconfig.friendHideOptinFriend;
    this.friendInfoAfterCode = data.friendconfig.friendInfoAfterCode;
    this.friAllowSameReward = data.friendconfig.friAllowSameReward;
    this.friendAllowMinimizeOnLastStep =
      data.friendconfig.friendAllowMinimizeOnLastStep;
    this.friYourCodeWillShowHereText =
      data.friendconfig.friYourCodeWillShowHereText;
    this.friOpenDealTagForExistingMember =
      data.friendconfig.friOpenDealTagForExistingMember;
    this.friOpenDealbytagbyIdentified =
      data.friendconfig.friOpenDealbytagbyIdentified;
    this.friDealtagafterfinish = data.friendconfig.friDealtagafterfinish;
    this.friRUAR = data.friendconfig.friRUAR;
    this.friAlreadyMemberHeader = data.friendconfig.friAlreadyMemberHeader; //changed
    this.friAlreadyMemberText = data.friendconfig.friAlreadyMemberText; //changed
    this.friEmailReminder = data.friendconfig.friEmailReminder;
    this.friendRemindBeforeDays = data.friendconfig.friendRemindBeforeDays;
    this.friendSecondRemindBeforeDays =
      data.friendconfig.friendSecondRemindBeforeDays;
    this.friEnableFriendMails = data.friendconfig.friEnableFriendMails;
    this.friendCampaignDealyDays = data.friendconfig.friendCampaignDealyDays;
    this.setTargetFriendURL = data.friendconfig.setTargetFriendURL;

    //Minimized
    this.ambRedirectlanding = data.minimized.ambRedirectlanding;
    this.ambCssSelector = data.minimized.ambCssSelector;
    this.ambcntdwn = data.minimized.ambcntdwn;
    this.ambshake = data.minimized.ambshake;
    this.ambshowMinWid = data.minimized.showMinWid;
    this.ambCustomerPopupMinimizeTitle =
      data.minimized.ambCustomerPopupMinimizeTitle;
    this.ambCustomerPopupMinTabCodeDel =
      data.minimized.ambCustomerPopupMinTabCodeDel;

    this.ambCustomerPopupMinimizeTitleMobile =
      data.minimized.ambCustomerPopupMinimizeTitleMobile;
    this.ambCustomerPopupMinTabCodeDelMobile =
      data.minimized.ambCustomerPopupMinTabCodeDelMobile;
    this.ambMobimghght = data.minimized.ambmobimghght;

    this.ambMobMinWidimgPath = data.minimized.mobMinWidimgPath;
    this.ambMobMinWidimgstream = data.minimized.mobMinWidimgstream;
    this.ambMobMinWidimgname = data.minimized.mobMinWidimgname;

    this.ambDeskMinWidimgPath = data.minimized.deskMinWidimgPath;
    this.ambDeskMinWidimgstream = data.minimized.deskMinWidimgstream;
    this.ambDeskMinWidimgname = data.minimized.deskMinWidimgname;
    this.ambMinDesktimghght = data.minimized.minDesktimghght;
    this.ambMinDesktimgwdth = data.minimized.minDesktimgwdth;
    this.ambMinMobimghght = data.minimized.minMobimghght;
    this.ambMinMobimgwdth = data.minimized.minMobimgwdth;

    this.ambCustomerPopupMinimizePosition =
      data.minimized.customerPopupMinimizePosition;
    this.ambMobileMinimizePosition = data.minimized.mobileMinimizePosition;
    this.setMinwidOffsetDesktopHor = data.minimized.minwidOffsetDesktopHor;
    this.setMinwidOffsetDesktopVer = data.minimized.minwidOffsetDesktopVer;
    this.setMinwidOffsetMobileHor = data.minimized.minwidOffsetMobileHor;
    this.setMinwidOffsetMobileVer = data.minimized.minwidOffsetMobileVer;
    this.ambExpireText = data.minimized.ambExpireText;
    this.setMinwidpadMobileL = data.minimized.setMinwidpadMobileL;
    this.setMinwidpadMobileB = data.minimized.setMinwidpadMobileB;
    this.setMinwidPopupButtonBackgroundColor =
      data.minimized.minwidPopupButtonBackgroundColor;
    // this.setMinwidPopupButtonTextColor =
    //   data.minimized.minwidPopupButtonTextColor;
    this.setPopupSelectedFont = data.minimized.popupSelectedFont;
    this.setPopupFontFileStream = data.minimized.popupFontFileStream;
    this.setPopupTitleFontFileStream = data.minimized.popupTitleFontFileStream;
    this.setPopupTitleFontFileName = data.minimized.popupTitleFontFileName;
    this.setPopupTitleFontName = data.minimized.popupTitleFontName;

    this.customerHeaderMobileMinimizeExpImage = {
      logoStream: data.minimized.ambCusHeadMobMinExpImglogoStream,
      logoPath: data.minimized.ambCusHeadMobMinExpImglogoPath,
      actualFileName: data.minimized.ambCusHeadMobMinExpImgactualFileName,
    };
    this.customerHeaderDesktopMinimizeExpImage = {
      logoPath: data.minimized.ambCusHeadDeskMinExpImglogoPath,
      defaultLogoPath: data.minimized.ambCusHeadDeskMinExpImgdefaultLogoPath,
      maxWidth: data.minimized.ambCusHeadDeskMinExpImgmaxWidth,
      maxHieght: data.minimized.ambCusHeadDeskMinExpImgmaxHieght,
      width: data.minimized.ambCusHeadDeskMinExpImgwidth,
      height: data.minimized.ambCusHeadDeskMinExpImgheight,
      actualFileName: data.minimized.ambCusHeadDeskMinExpImgactualFileName,
      // isRequired: data.minimized.ambCusHeadDeskMinExpImgisRequired || false,
      logoStream: data.minimized.ambCusHeadDeskMinExpImglogoStream,
    };

    this.setMinwidPopupButtonTextColor =
      data.minimized.minwidPopupButtonTextColor;
    this.setWidgetShadowColor = data.minimized.setWidgetShadowColor;

    ///Maximized
    //maximized page

    this.ambCustomTagsTitle = data.maximized.ambCustomTagsTitle;
    this.ambCustomFieldName = data.maximized.ambCustomFieldName;
    this.ambCustomtags = data.maximized.ambCustomtags;
    this.ambRequireAns = data.maximized.ambRequireAns;
    this.ambDropdown = data.maximized.ambDropdown;
    this.ambMultiAns = data.maximized.ambMultiAns;
    this.ambCustomtagstype = data.maximized.ambCustomtagstype;

    this.ambHideOptinAmbassador = data.maximized.ambHideOptinAmbassador;
    this.ambShowEmail = data.maximized.ambShowEmail;
    this.ambShowPhoneNumber = data.maximized.ambShowPhoneNumber;
    this.ambShowPersonalNumber = data.maximized.ambShowPersonalNumber;
    this.ambIsRequireAmbassadorName = data.maximized.ambIsRequireAmbassadorName;
    this.ambIsRequireFNameLName =
      data.maximized.ambIsRequireFNameLName || false;
    this.ambEnableBirthday = data.maximized.ambEnableBirthday;
    this.ambEnableCustomTextField = data.maximized.ambEnableCustomTextField;
    this.ambEnableSingleSelectOptions =
      data.maximized.ambEnableSingleSelectOptions;
    this.ambEnableConsents = data.maximized.ambEnableConsents;
    this.ambrevfcc = data.maximized.ambrevfcc;
    this.ambIsRequireOptIn = data.maximized.ambIsRequireOptIn;
    this.setMoveTermsTextUnderWidget =
      data.maximized.setMoveTermsTextUnderWidget;
    this.setShowConsentTextAlways = data.maximized.setShowConsentTextAlways;
    this.ambRequireconsent = data.maximized.ambRequireconsent;
    this.setaufforprefill = data.maximized.setaufforprefill;
    this.setAllowupdatefield = data.maximized.setAllowupdatefield;
    this.setBlockFlowAPIError = data.maximized.setBlockFlowAPIError;
    this.setfontsizefortitle = data.maximized.setfontsizefortitle || "";
    this.widgetShadowBlur = data.maximized.widgetShadowBlur || "";
    this.widgetCornerRound = data.maximized.widgetCornerRound || "";
    this.setfontsizeformsg = data.maximized.fontsizeformsg || "";
    this.setfontsizeforcta = data.maximized.fontsizeforcta || "";
    this.setfontsizefortitle = data.maximized.fontsizefortitle || "";

    this.ambMobimgwdth = data.maximized.ambMobimgwdth;
    this.ambMobHeaderimagestream = data.maximized.ambmobHeaderimagestream || "";
    this.ambMobHeaderimagename = data.maximized.ambmobHeaderimagename || "";
    this.ambMobHeaderimagepath = data.maximized.ambmobHeaderimagepath || "";
    this.ambEmailText = data.maximized.ambEmailText || "";
    this.ambbirthdayTitle = data.maximized.ambbirthdayTitle || "";
    this.ambCustomTextFieldLabel = data.maximized.ambCustomTextFieldLabel || "";
    this.ambCustomTextField = data.maximized.ambCustomTextField || "";
    this.ambEnableSelectOption = data.maximized.ambEnableSelectOption || "";
    this.ambConsents = data.maximized.ambConsents || "";
    this.ambCustomerCheckoutWelcomeTitle =
      data.maximized.ambcustomerCheckoutWelcomeTitle || "";
    this.ambCustomerCheckoutWelcomeBody =
      data.maximized.ambcustomerCheckoutWelcomeBody || "";
    this.ambnotCombinedWidgetHeader =
      data.maximized.ambnotCombinedWidgetHeader || "";
    this.ambnotCombinedWidgetBodytxt =
      data.maximized.ambnotCombinedWidgetBodytxt || "";
    this.setAmbassadorOptInYes = data.maximized.setAmbassadorOptInYes || "";
    this.setAmbassadorOptInNo = data.maximized.setAmbassadorOptInNo || "";
    this.ambAmbassadorTermConsentText =
      data.maximized.ambassadorTermConsentText || "";
    this.ambVoyadoMemberType = data.maximized.ambVoyadoMemberType || "";
    this.ambVoyadoExternalId = data.maximized.ambVoyadoExternalId || "";
    this.ciTag = data.maximized.ciTag || "";
    this.ambciFieldName = data.maximized.ambciFieldName || "";
    this.ambciFieldValue = data.maximized.ambciFieldValue || "";
    this.setBlockFlowErrorHeader = data.maximized.setBlockFlowErrorHeader || "";
    this.setBlockFlowErrorMsg = data.maximized.setBlockFlowErrorMsg || "";
    this.ciErrorHeader = data.maximized.ciErrorHeader || "";
    this.ciErrorMessage = data.maximized.ciErrorMessage || "";
    this.ambCustomerInfoBlockButtonLabel =
      data.maximized.ambCustomerInfoBlockButtonLabel || "";
    this.ambMailScreenButtonLable =
      data.maximized.ambMailScreenButtonLable || "";
    this.ambCustomerInfoChooseWay =
      data.maximized.ambCustomerInfoChooseWay || "";
    this.ambCustomerInfoDoneButtonLabel =
      data.maximized.ambCustomerInfoDoneButtonLabel || "";
    this.ambAmbassadorCloseButton = data.maximized.ambassadorCloseButton;
    this.ambAmbassadorSLCTAButton = data.maximized.ambassadorSLCTAButton;
    this.ambCustomerInfoTargetChooseBtn =
      data.maximized.ambCustomerInfoTargetChooseBtn || "";

    this.setPopupButtonTextColor = data.maximized.popupButtonTextColor;
    this.setPopupButtonBackgroundColor =
      data.maximized.popupButtonBackgroundColor;
    this.setCTAbuttonwidth = data.maximized.setCTAbuttonwidth || "";
    // this.widgetShadowColor = data.maximized.setWidgetShadowColor || "";
    this.ambIsHighlightAmbassadorCTAButton =
      data.maximized.ambIsHighlightAmbassadorCTAButton || true;
    this.setWidgetBackgroundColor = data.maximized.widgetBackgroundColor;
    this.setTextColor = data.maximized.setTextColor;

    this.ambHeaderimagepath = data.maximized.ambheaderimagepath || "";
    this.ambHeaderimagestream = data.maximized.ambheaderimagestream || "";
    this.ambHeaderimagename = data.maximized.ambheaderimagename || "";
    this.ambDesktimghght = data.maximized.ambDesktimghght;
    this.ambDesktimgwdth = data.maximized.ambDesktimgwdth;
    this.ambcustomtags = data.maximized.ambcustomtags || "";

    //message
    this.ambCustomerSecondRemindBeforeDays =
      data.message.ambCustomerSecondRemindBeforeDays;
    this.ambCustomerRemindBeforeDays = data.message.ambCustomerRemindBeforeDays;
    this.ambCustomerCampaignDealyDays =
      data.message.ambCustomerCampaignDealyDays;
    this.ambCustomerBarcodeImgFileName =
      data.message.ambCustomerBarcodeImgFileName;
    this.ambCustomerEANBarCodeText = data.message.ambCustomerEANBarCodeText;
    this.ambCustomerEANBarCodeTextExisting =
      data.message.ambCustomerEANBarCodeTextExisting;
    this.ambCustomerBarcodeImgFullPath =
      data.message.ambCustomerBarcodeImgFullPath;

    this.ambSaveCode = {
      subject: data.message.ambSaveCodesubject,
      subhead: data.message.ambSaveCodesubhead,
      body: data.message.ambSaveCodebody,
      ctabutton: data.message.ambSaveCodectabutton,
    };

    this.ambFirstReminder = {
      subject: data.message.ambFirstRemsubject,
      subhead: data.message.ambFirstRemsubhead,
      body: data.message.ambFirstRembody,
      ctabutton: data.message.ambFirstRemctabutton,
    };
    this.ambSecondReminder = {
      subject: data.message.ambSecRemsubject,
      subhead: data.message.ambSecRemsubhead,
      body: data.message.ambSecRembody,
      ctabutton: data.message.ambSecRemctabutton,
    };

    //Return visit
    this.ambCustomerThanksScreenTitle =
      data.returnvisit.ambCustomerThanksScreenTitle;
    this.ambCustomerThanksScreenBody =
      data.returnvisit.ambCustomerThanksScreenBody;
    this.ambRewardpagebody = data.returnvisit.ambrewardpagebody;
    this.ambCustomerCouponScreenTitle =
      data.returnvisit.ambCustomerCouponScreenTitle;
    this.ambCustomerCouponScreenTerms =
      data.returnvisit.ambCustomerCouponScreenTerms;
    this.ambCustomerCouponScreenBody =
      data.returnvisit.ambCustomerCouponScreenBody;
    this.setCouponExpiredHeader = data.returnvisit.setCouponExpiredHeader;
    this.setCouponExpiredMessage = data.returnvisit.setCouponExpiredMessage;
    this.setDealExpiredHeader = data.returnvisit.setDealExpiredHeader;
    this.setDealExpiredMessage = data.returnvisit.setDealExpiredMessage;
    this.setVoyadorewardusetitle = data.returnvisit.setVoyadorewardusetitle;
    this.setVoyadorewardusebody = data.returnvisit.setVoyadorewardusebody;
    this.setVoyadorewardassigntitle =
      data.returnvisit.setVoyadorewardassigntitle;
    this.setVoyadorewardassignbody = data.returnvisit.setVoyadorewardassignbody;
    this.setOtherVoyadorewardassigntitle =
      data.returnvisit.setOtherVoyadorewardassigntitle;
    this.setOtherVoyadorewardassignbody =
      data.returnvisit.setOtherVoyadorewardassignbody;
    this.ambAlreadymemberheader = data.returnvisit.ambAlreadymemberheader;
    this.ambAlreadymembertext = data.returnvisit.ambAlreadymembertext;

    //friend message

    this.friSaveCode = {
      subject: data.friendmessage.friSaveCodesubject,
      body: data.friendmessage.friSaveCodebody,
      ctabutton: data.friendmessage.friSaveCodectabutton,
    };

    this.friFirstReminder = {
      subject: data.friendmessage.friFirstRemsubject,
      subhead: data.friendmessage.friFirstRemsubhead,
      body: data.friendmessage.friFirstRembody,
      ctabutton: data.friendmessage.friFirstRemctabutton,
    };

    this.friSecondReminder = {
      subject: data.friendmessage.friSecRemsubject,
      subhead: data.friendmessage.friFirstRemsubhead,
      body: data.friendmessage.friSecRembody,
      ctabutton: data.friendmessage.friSecRemctabutton,
    };

    //friend return visit
    this.friendThanksScreenTitle =
      data.friendreturnvisit.friendThanksScreenTitle || "";
    this.friendThanksScreenBody =
      data.friendreturnvisit.friendThanksScreenBody || "";

    //Friend maximized
    //riddhi
    this.friShowEmail = data.friendmaximized.friShowEmail;
    this.friRequireAns = data.friendmaximized.friRequireAns;
    this.friCustomtags = data.friendmaximized.friCustomtags;
    this.friCustomtagstype = data.friendmaximized.friCustomtagstype;
    this.friDropdown = data.friendmaximized.friDropdown;
    this.friMultiAns = data.friendmaximized.friMultiAns;
    this.friCustomTagsTitle = data.friendmaximized.friCustomTagsTitle;
    this.friCustomFieldName = data.friendmaximized.friCustomFieldName;
    this.friShowPhoneNumber = data.friendmaximized.friShowPhoneNumber;
    this.friShowPersonalNumber = data.friendmaximized.friShowPersonalNumber;
    this.friendIsRequireFriendName =
      data.friendmaximized.friendIsRequireFriendName;
    this.FriIsRequireFriFNameLName =
      data.friendmaximized.FriIsRequireFriFNameLName || false;
    this.friEnableBirthday = data.friendmaximized.friEnableBirthday;
    this.friEnableCustomTextField =
      data.friendmaximized.friEnableCustomTextField;
    this.friEnableConsents = data.friendmaximized.friEnableConsents || true;
    this.friEnableSingleSelectOptions =
      data.friendmaximized.friEnableSingleSelectOptions;
    this.friendIsFriendRequireOptIn =
      data.friendmaximized.friendIsFriendRequireOptIn;
    this.friRequireconsent = data.friendmaximized.friRequireconsent;
    this.frirevfcc = data.friendmaximized.frirevfcc;
    this.friendIsShowCTAButtonCenter =
      data.friendmaximized.friendIsShowCTAButtonCenter;
    this.friendIsHighlightCTAButton =
      data.friendmaximized.friendIsHighlightCTAButton;
    /////////
    this.friMobHeaderimagename = data.friendmaximized.friMobHeaderimagename;
    this.friHeaderimagepath = data.friendmaximized.friHeaderimagepath;
    this.friHeaderimagename = data.friendmaximized.friHeaderimagename;
    this.friendCouponScreenBodySmall =
      data.friendmaximized.friendCouponScreenBodySmall;
    this.friendCouponScreenTerms = data.friendmaximized.friendCouponScreenTerms;
    this.friEmailText = data.friendmaximized.friEmailText;
    this.friBirthdayTitle = data.friendmaximized.friBirthdayTitle;
    this.friCustomTextFieldLabel = data.friendmaximized.friCustomTextFieldLabel;
    this.friCustomTextField = data.friendmaximized.friCustomTextField;
    this.friEnableSelectOption = data.friendmaximized.friEnableSelectOption;
    this.friConsents = data.friendmaximized.friConsents;
    this.friCustomerCheckoutWelcomeTitle =
      data.friendmaximized.friCustomerCheckoutWelcomeTitle;
    this.friCustomerCheckoutWelcomeBody =
      data.friendmaximized.friCustomerCheckoutWelcomeBody;
    this.frinotCombinedWidgetHeader =
      data.friendmaximized.frinotCombinedWidgetHeader;
    this.frinotCombinedWidgetBodytxt =
      data.friendmaximized.frinotCombinedWidgetBodytxt;
    this.friendFirstSendButton = data.friendmaximized.friendFirstSendButton;
    this.friendFirstCloseButton = data.friendmaximized.friendFirstCloseButton;
    this.friendGetYourCodeButton = data.friendmaximized.friendGetYourCodeButton;
    this.friendCloseButtonAfterreward =
      data.friendmaximized.friendCloseButtonAfterreward;
    this.friSaveRemindMeButton = data.friendmaximized.friSaveRemindMeButton;
    this.friSaveOfferForLaterText =
      data.friendmaximized.friSaveOfferForLaterText;
    this.setFriendOptInYes = data.friendmaximized.setFriendOptInYes;
    this.setFriendOptInNo = data.friendmaximized.setFriendOptInNo;
    this.friendTermConsentText = data.friendmaximized.friendTermConsentText;
    this.friVoyadoMemberType = data.friendmaximized.friVoyadoMemberType;
    this.friVoyadoExternalId = data.friendmaximized.friVoyadoExternalId;
    this.friciFieldName = data.friendmaximized.friciFieldName;
    this.friciFieldValue = data.friendmaximized.friciFieldValue;
    this.friHeaderimagestream = data.friendmaximized.friHeaderimagestream;
    this.friDesktimghght = data.friendmaximized.friDesktimghght;
    this.friDesktimgwdth = data.friendmaximized.friDesktimgwdth;
    this.friMobHeaderimagestream = data.friendmaximized.friMobHeaderimagestream;
    this.friMobHeaderimagepath = data.friendmaximized.friMobHeaderimagepath;
    this.friCustomtags = data.friendmaximized.friCustomtags;

    this.friCustomerHeaderMobileMinimizeExpImage = {
      logoStream: data.friendminimized.friCusHeadMobMinExpImglogoStream,
      logoPath: data.friendminimized.friCusHeadMobMinExpImglogoPath,
      actualFileName: data.friendminimized.friCusHeadMobMinExpImgactualFileName,
      logoName: data.friendminimized.friCusHeadMobMinExpImgLogoName,
    };

    this.friCustomerHeaderDesktopMinimizeExpImage = {
      logoPath: data.friendminimized.friCusHeadDeskMinExpImglogoPath,
      defaultLogoPath:
        data.friendminimized.friCusHeadDeskMinExpImgdefaultLogoPath,
      maxWidth: data.friendminimized.friCusHeadDeskMinExpImgmaxWidth,
      maxHieght: data.friendminimized.friCusHeadDeskMinExpImgmaxHieght,
      width: data.friendminimized.friCusHeadDeskMinExpImgwidth,
      height: data.friendminimized.friCusHeadDeskMinExpImgheight,
      actualFileName:
        data.friendminimized.friCusHeadDeskMinExpImgactualFileName,
      logoStream: data.friendminimized.friCusHeadDeskMinExpLogoStream,
      logoName: data.friendminimized.friCusHeadDeskMinExpLogoName,
    };

    //desktop
    this.friDeskMinWidimgPath = data.friDeskMinWidimgPath;
    this.friDeskMinWidimgname = data.friDeskMinWidimgname;
    this.friDeskMinWidimgstream = data.friDeskMinWidimgstream;
    this.friDesktimghght = data.friDesktimghght;
    this.friDesktimgwdth = data.friDesktimgwdth;

    //mobile
    this.friMinMobimghght = data.friMinMobimghght;
    this.friMobHeaderimagename = data.friMobHeaderimagename;
    this.friMobHeaderimagepath = data.friMobHeaderimagepath;
    this.friMobHeaderimagestream = data.friMobHeaderimagestream;

    this.friMobMinWidimgPath = data.friMobMinWidimgPath;
    this.friMobMinWidimgname = data.friMobMinWidimgname;
    this.friMobMinWidimgstream = data.friMobMinWidimgstream;

    this.friendPopupMinimizeTitle = data.friendPopupMinimizeTitle;


    // settings
    this.setCompanyId = data.setCompanyId;

    this.setFbShareLandingUrlExisting =
      data.setFbShareLandingUrlExisting || false;
    this.setPopupTitleSelectedFont = data.setPopupTitleSelectedFont || false;
    this.setIsCloudSponge = data.setIsCloudSponge || false;
    this.setPopupFontFileName = data.setPopupFontFileName || false;
    this.setPopupFontFilePath = data.setPopupFontFilePath || false;
    this.setCampaignFontGuid = data.setCampaignFontGuid || false;

    this.setPopupTitleFontFilePath = data.setPopupTitleFontFilePath || "";
    this.setCampaignTitleFontGuid = data.setCampaignTitleFontGuid || "";

    this.setIsActionDeal = data.setIsActionDeal || false;

    this.shortenURLQRCode = data.setShortenURLQRCode;
    this.setTodayIssuedCodesAmount = data.setTodayIssuedCodesAmount;
    this.setAllIssuedCodesAmount = data.setAllIssuedCodesAmount;
    this.setWidgetDesktopVerticalOffset = data.setWidgetDesktopVerticalOffset;
    // this.setTempTargetCampaignURL = data.setTempTargetCampaignURL;
    this.setIsContactIntegrated = data.setIsContactIntegrated;

    this.setMinWidFontSize = data.setMinWidFontSize;
    this.setMinWidSelectedFont = data.setMinWidSelectedFont;
    this.setMinWidFontFileName = data.setMinWidFontFileName;
    this.setMinWidFontName = data.setMinWidFontName;
    this.setMinWidCustFontName = data.setMinWidCustFontName;
    this.setMinWidFontFilePath = data.setMinWidFontFilePath;
    this.minWidFontFileStream = data.minWidFontFileStream;

    // this.setMinwidpadDesktopL = data.setMinwidpadDesktopL;
    this.setMinwidpadDesktopR = data.setMinwidpadDesktopR;
    this.setMinwidpadDesktopT = data.setMinwidpadDesktopT;
    this.setMinwidpadDesktopB = data.setMinwidpadDesktopB;
    this.setMinwidpadMobileR = data.setMinwidpadMobileR;
    this.setMinwidpadMobileT = data.setMinwidpadMobileT;

    this.setAllowCTAbuttonwidth = data.setAllowCTAbuttonwidth;
    this.setVoyadorewardusebody = data.setVoyadorewardusebody;
    this.setMinWidTxtD = data.setMinWidTxtD;
    this.setMinWidTxtM = data.setMinWidTxtM;
    this.setWidgetCornerRound = data.setWidgetCornerRound;
    this.setMinWidgetCornerRound = data.setMinWidgetCornerRound;
    this.setWidgetShadow = data.setWidgetShadow;
    this.setImageBorder = data.setImageBorder;

    this.ciFieldName = data.ciFieldName;
    this.ciFieldValue = data.ciFieldValue;
    this.emailChannelStoringHeaderUserAppeal =
      data.emailChannelStoringHeaderUserAppeal;

    this.isSMSChannelEnable = data.isSMSChannelEnable;
    this.isEMailChannelEnable = data.isEMailChannelEnable;
    this.isMessengerChannelEnable = data.isMessengerChannelEnable;
    this.isWhatsAppChannelEnable = data.isWhatsAppChannelEnable;
    this.isShareableLinkChannelEnable = data.isShareableLinkChannelEnable;
    this.isQRChannelEnable = data.isQRChannelEnable;
    this.isTwitterChannelEnable = data.isTwitterChannelEnable;
    this.isWeChatChannelEnable = data.isWeChatChannelEnable;
    this.isLineChannelEnable = data.isLineChannelEnable;
    this.isKakaotalkChannelEnable = data.isKakaotalkChannelEnable;
    this.isWebShareChannelEnable = data.isWebShareChannelEnable;
    this.isPageShareChannelEnable = data.isPageShareChannelEnable;
    this.isSkypeChannelEnable = data.isSkypeChannelEnable;
    this.isDiscordChannelEnable = data.isDiscordChannelEnable;
    this.isSignalChannelEnable = data.isSignalChannelEnable;
    this.isInstagramChannelEnable = data.isInstagramChannelEnable;
    this.isTrueCallerChannelEnable = data.isTrueCallerChannelEnable;
    this.isTelegramChannelEnable = data.isTelegramChannelEnable;

    this.extSavingCodeEmailSubject = data.extSavingCodeEmailSubject;
    this.extReminderEmailSubject = data.extReminderEmailSubject;
    this.extFriendSavingCodeEmailSubject = data.extFriendSavingCodeEmailSubject;
    this.extEmailCodeSavingButtonText = data.extEmailCodeSavingButtonText;
    this.extEmailReminderButtonText = data.extEmailReminderButtonText;
    this.setbtnvp = data.setbtnvp;
    this.setbtnhp = data.setbtnhp;

    this.ambCustomerPopupPosition = data.ambCustomerPopupPosition || "center";
    this.ambCustomerStaticPin = data.ambCustomerStaticPin;
    this.ambCustomerCodeFileNameOld = data.ambCustomerCodeFileNameOld;
    this.ambCustomerCodesUpdate = data.ambCustomerCodesUpdate;
    this.ambcustomerCouponsLeft = data.ambcustomerCouponsLeft;
    this.ambIsCollectCustomerInfoEarly = data.ambIsCollectCustomerInfoEarly;

    this.ambCombineChannelInfoStep = data.ambCombineChannelInfoStep;
    // this.ambFlowType = data.ambFlowType || "IdentityFirstThenChannel";
    
   
    this.ambCombineChannelInfoStepMobile = data.ambCombineChannelInfoStepMobile;
    this.ambAmbassadorInfoTitle = data.ambAmbassadorInfoTitle;
    this.ambShowCodeInPopup = data.ambShowCodeInPopup;

    this.ambCustomerEmailCouponReminderMessage =
      data.ambCustomerEmailCouponReminderMessage;
    this.ambCustomerEmailCouponSecondReminderMessage =
      data.ambCustomerEmailCouponSecondReminderMessage;
    this.ambCombineChannelInfoOnStep1 = data.ambCombineChannelInfoOnStep1;
    this.ambCombineChannelInfoOffStep1 = data.ambCombineChannelInfoOffStep1;
    this.ambCombineChannelInfoOffStep2 = data.ambCombineChannelInfoOffStep2;
    this.ambOptionScreenChannelText = data.ambOptionScreenChannelText;
    this.ambCombineOptionScreenChannelText =
      data.ambCombineOptionScreenChannelText;
    this.ambPickAnotherFriendText = data.ambPickAnotherFriendText;
    this.ambMoreOptionScreenChannelText = data.ambMoreOptionScreenChannelText;
    this.ambConversionTitle = data.ambConversionTitle;
    this.ambConversionDescriptionText = data.ambConversionDescriptionText;
    this.ambCustomTagsMultiSelection = data.ambCustomTagsMultiSelection;
    this.ambCustomtagstype = data.ambCustomtagstype;
    this.ambCustomFieldMandatory = data.ambCustomFieldMandatory;
    this.ambCustomTagsTitle = data.ambCustomTagsTitle;
    this.ambCustomFieldName = data.ambCustomFieldName;
    this.ambCustomTextKey = data.ambCustomTextKey;

    this.ambFrinedRewardTime = data.ambFrinedRewardTime;
    this.ambAmbassadorTriggers = data.ambAmbassadorTriggers; //changed
    this.ambAmbassadorMaximumFontNoPage = data.ambAmbassadorMaximumFontNoPage;

    this.ambshowImageRight = data.ambShowImageRight;
    this.ambAllowSameReward = data.ambAllowSameReward;
    this.ambRewardpageheader = data.ambRewardpageheader;
    this.ambCodeValue = data.ambCodeValue;
    this.ambDoNotShowDealSession = data.ambDoNotShowDealSession;
    this.ambShowIfDealTagCompleted = data.ambShowIfDealTagCompleted;
    this.ambShowtriggerpersession = data.ambShowtriggerpersession;
    this.ambShownevertriggerpersession = data.ambShownevertriggerpersession;
    this.ambShowIfDealTag = data.ambShowIfDealTag;

    this.ambCiCheckbox = data.ambCiCheckbox;
    this.ambCiCheckboxTitle = data.ambCiCheckboxTitle;
    this.ambCiCheckBoxFields = data.ambCiCheckBoxFields;
    this.ambMaxaftidletime = data.ambMaxaftidletime;
    this.ambShowidentiuser = data.ambShowidentiuser;
    this.ambShowunidentiuser = data.ambShowunidentiuser;
    this.ambShowloogedinuser = data.ambShowloogedinuser;
    this.ambShowneverloogedinuser = data.ambShowneverloogedinuser;
    this.ambShowtoexistingcustomer = data.ambShowtoexistingcustomer;
    this.ambShowtonewcustomer = data.ambShowtonewcustomer;
    this.ambShowuserinaudience = data.ambShowuserinaudience;
    this.ambShowusernotinaudience = data.ambShowusernotinaudience;
    this.ambShowusernotinaudiencevalue = data.ambShowusernotinaudiencevalue;
    this.ambShowToSubscribers = data.ambShowToSubscribers;
    this.ambShowToNonSubscribers = data.ambShowToNonSubscribers;

    this.isDraft = data.isDraft || false;
    this.postEvent = data.postEvent;

    this.friendPopupPosition = "center";
    this.clientTimezoneOffset = data.clientTimezoneOffset;
  }
}
